import { Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Select, MenuItem } from '@mui/material';
import { useState } from 'react';
import CopyAll from '@mui/icons-material/CopyAll';
import { postCreateApiKey } from '../../../utilities/api';

type Props = {
    email: string | null;
    onClose: (email: string | null) => void;
};

export const UserApiKey = ({ email, onClose }: Props) => {
    const [apiKey, setApiKey] = useState('');
    const [password, setPassword] = useState('');
    const [expiresIn, setExpiresIn] = useState('1y');

    const handleCreateApiKey = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            if (!email) return;

            const { token } = await postCreateApiKey({ email, password, expiresIn });

            setApiKey(token);
        } catch (_) {
            setApiKey('ERROR');
        }
    };

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(apiKey);
    };

    const handleClose = () => {
        setPassword('');
        setApiKey('');
        setExpiresIn('1y');
        onClose(null);
    };

    return (
        <Dialog open={Boolean(email)} onClose={handleClose} sx={{ paper: { backgroundColor: 'white' } }}>
            <DialogTitle>Create ApiKey</DialogTitle>
            <DialogContent sx={(theme) => ({ minWidth: theme.breakpoints.values.sm })}>
                <form onSubmit={handleCreateApiKey} id="create-apikey-form" noValidate>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
                        <TextField autoFocus required fullWidth name="password" label="Password" type="password" variant="outlined" value={password} onChange={({ target }) => setPassword(target.value)} />
                        <FormControl fullWidth>
                            <InputLabel id="expires-in-select">Expires In</InputLabel>
                            <Select labelId="expires-in-select" id="expiresIn" value={expiresIn} name="expiresIn" label="Expires In" onChange={({ target }) => setExpiresIn(target.value)}>
                                <MenuItem value={'1y'}>One Year</MenuItem>
                                <MenuItem value={'2y'}>Two Years</MenuItem>
                                <MenuItem value={'5y'}>Five Years</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined">
                            <OutlinedInput
                                readOnly
                                disabled
                                name="apikey"
                                value={apiKey}
                                startAdornment="ApiKey: "
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton aria-label="copy key" edge="end" onClick={handleCopyToClipboard}>
                                            <CopyAll />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Box>
                </form>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="contained" type="submit" form="create-apikey-form">
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};
